module.exports = __webpack_public_path__ + "static/felixpago-0ac4a3d751d7fa06145b12e9768ef86e.png";